import { render, staticRenderFns } from "./accidentBasicData.vue?vue&type=template&id=ce0dfe7a&scoped=true"
import script from "./accidentBasicData.vue?vue&type=script&lang=js"
export * from "./accidentBasicData.vue?vue&type=script&lang=js"
import style0 from "./accidentBasicData.vue?vue&type=style&index=0&id=ce0dfe7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0dfe7a",
  null
  
)

export default component.exports